import React from 'react'
import { FormField } from 'semantic-ui-react'
import {themes} from '@/theme/context'

import { ServiceWrapper, StyledRadio } from './style';

interface Props {
    selectedOrg: any
    selectedService: string
    handleSelectService: any
}

const Services: React.FC<Props> = ({ selectedOrg, selectedService,  handleSelectService}) => {
    const services = {
        diag: 'Диагностика',
        ias: 'Интернет-тренажеры',
        fepo: 'ФЭПО',
        fieb_tren: 'Тренажер ФИЭБ'
    }

    return (
        <ServiceWrapper id='services'>
            {Object.keys(services).reduce<any[]>((acc, service) => {
                let themeAct = service
                if (service == 'fieb_tren') themeAct = 'fieb'
                if (selectedOrg?.orgType == 'ssuz' && service == 'fieb_tren') return acc

                acc.push(
                    <FormField key={service} id={`service_${service}`}>
                        <StyledRadio
                            label={services[service]}
                            name='actMods'
                            value={service}
                            $color={themes[themeAct]?.primaryColor}
                            checked={service == selectedService}
                            onChange={handleSelectService}
                        />
                    </FormField>
                )
                return acc
            }, [])}
        </ServiceWrapper>
    );
}

export default Services